/** @format */

export const ViewLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.9997 12C17.0605 12 18.078 12.4214 18.8281 13.1716C19.5782 13.9217 19.9997 14.9391 19.9997 16C19.9997 17.0609 19.5782 18.0783 18.8281 18.8284C18.078 19.5786 17.0605 20 15.9997 20C14.9388 20 13.9214 19.5786 13.1712 18.8284C12.4211 18.0783 11.9997 17.0609 11.9997 16C11.9997 14.9391 12.4211 13.9217 13.1712 13.1716C13.9214 12.4214 14.9388 12 15.9997 12ZM15.9997 6C22.6663 6 28.3597 10.1467 30.6663 16C28.3597 21.8533 22.6663 26 15.9997 26C9.33301 26 3.63967 21.8533 1.33301 16C3.63967 10.1467 9.33301 6 15.9997 6ZM4.23967 16C6.43967 20.48 10.9863 23.3333 15.9997 23.3333C21.013 23.3333 25.5597 20.48 27.7597 16C25.5597 11.52 21.013 8.66667 15.9997 8.66667C10.9863 8.66667 6.43967 11.52 4.23967 16Z"
                fill={color}
            />
        </svg>
    );
};
